export const baseUrl = 'https://tofino1.com'
export const baseReportUrl = 'https://tofino1.com'
